export const CONTACT_PAGE_FS_SCHEMA_CTAS = JSON.stringify({
  'data-type': 'str',
})

export const PHARMA_CTA_TYPE = 'topics.pharma.CTA'
export const ACCOUNT_HELP_CTA_TYPE = 'topics.accountHelp.CTA'
export const CONTACT_FALLBACK_CTA_TYPE = 'amazonisation.contactFallbackCTA'
